module.exports = __webpack_public_path__ + "static/media/ic_insert_drive_file_black_36px_selected.efdd2807.svg";